import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <UpdatesSection />
        <CarouselSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
        <IndexSection />
        <CardsSection />
        <FeaturesSection />
        <AppSection />
        <FaqSection />
        <CommentsSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}